import { RECEIVE_AIRPORTS, REQUEST_AIRPORTS } from '../actions/airports'

export const initialState = {
  isFetching: false,
  status: 'initial',
  list: [],
}

function airports(state = initialState, action = {}) {
  switch (action.type) {
    case RECEIVE_AIRPORTS:
      return {
        isFetching: false,
        list: action.data.airports,
        status: action.data.status,
      }
    case REQUEST_AIRPORTS:
      return {
        ...state,
        isFetching: true,
      }
    default:
      return state
  }
}

export default airports
